// @ts-nocheck
/* eslint-disable */
import MD5 from './md5'
import { encode, decode } from './base64';

const randomCoding = () => {
    //创建26个字母数组
    let arr = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
    let idvalue = '';
    let n = 4;//这个值可以改变的，对应的生成多少个字母，根据自己需求所改
    for (var i = 0; i < n; i++) {
        idvalue += arr[Math.floor(Math.random() * 26)];
    }
    return idvalue;
}


const encry = (username = '', nickname = '', password = '', type = '', ispassword = '', token = '', avatar = '', job = '', date) => {
    console.log('encry:', { username, nickname, password, type, ispassword, token, date, avatar })
    // d暂设奇数,偶数会出问题
    let d = 3, e;
    let _password = password.split('').reverse().join('')
    let _token = token.split('').reverse().join('')
    let _job = job.split('').reverse().join('')
    if (d % 2) {
        e = randomCoding() + '=' + username +
            '&' + randomCoding() + '=' + nickname +
            '&' + randomCoding() + '=' + encode(_password) +
            '&' + randomCoding() + '=' + (type + '') +
            '&' + randomCoding() + '=' + (ispassword + '') +
            '&' + randomCoding() + '=' + _token +
            '&' + randomCoding() + '=' + encode(avatar) +
            '&' + randomCoding() + '=' + encode(_job)
    } else {
        e = randomCoding() + '=' + encode(_job) +
            '&' + randomCoding() + '=' + encode(avatar) +
            '&' + randomCoding() + '=' + _token +
            '&' + randomCoding() + '=' + (ispassword + '') +
            '&' + randomCoding() + '=' + (type + '') +
            '&' + randomCoding() + '=' + encode(_password) +
            '&' + randomCoding() + '=' + nickname +
            '&' + randomCoding() + '=' + username
    }

    let ene = encodeURIComponent(e)
    let r = ene + '&ep=' + MD5(d + username + nickname + password + type + ispassword + token + avatar + job) + '&d=' + d
    console.log('encry finish:', r)
    return r
}

const equalEp = (data = {}) => {
    let { username, nickname = '', password = '', type = '', ispassword = '', token = '', avatar = '', job = '', d = 0 } = data
    return MD5(d + username + nickname + password + type + ispassword + token + avatar + job)
}

export default encry

export { equalEp }